import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ItemDto } from '../models/item-dto.model';
import { ApiServiceBase } from './base/api-service-base';

@Injectable({ providedIn: 'root' })
export class ItemService extends ApiServiceBase {
  //#region Constructor
  constructor(
    private readonly _httpClient: HttpClient
  ) {
    super();
  }
  //#endregion

  //#region Private properties
  private readonly _itemControllerUrl: string = "/api/Item";
  //#endregion

  //#region Public methods
  public findByIntegrationGroup$(integrationGroupID: string): Observable<ItemDto[]> {
    return super.catchErrorResponse(this._httpClient.get<ItemDto[]>(`${this._itemControllerUrl}/integrationgroup/${integrationGroupID}`));
  }
  //#endregion
}
